import NotificationPanel from './NotificationPanel';

export default NotificationPanel;
